import { Utilities } from './Utilities';
export class Page {
    constructor() {
        this.divPage = document.body.querySelector('#page');
        this.stickyTopSectionsHolder = document.body.querySelector('#pgb-top-holder');
        this.stickyBottomSectionsHolder = document.body.querySelector('#pgb-bottom-holder');
        this.setupStickySections();
    }
    updateVisibility() {
        const hidden = document.body.querySelectorAll('[data-hidden="true"]');
        const notHidden = document.body.querySelectorAll('[data-hidden="false"]');
        Utilities.forEach(hidden, element => {
            element.style.display = 'none';
            element.style.position = 'fixed';
            element.style.left = '-99999';
        });
        Utilities.forEach(notHidden, element => {
            element.style.display = '';
            element.style.position = 'relative';
            element.style.left = 'auto';
        });
    }
    hasStickySections() {
        return !!document.body.querySelector('.pgb-js-stick-top, .pgb-js-stick-bottom');
    }
    repositionStickySections() {
        const stickyTopSections = document.body.querySelectorAll('.pgb-js-stick-top');
        const stickyBottomSections = document.body.querySelectorAll('.pgb-js-stick-bottom');
        stickyTopSections.forEach(element => {
            element.parentNode.removeChild(element);
            this.stickyTopSectionsHolder.appendChild(element);
        });
        stickyBottomSections.forEach(element => {
            element.parentNode.removeChild(element);
            this.stickyBottomSectionsHolder.appendChild(element);
        });
    }
    createPlaceholder() {
        const div = document.createElement('div');
        div.classList.add('sticky-placeholder');
        return div;
    }
    createStickyPlaceholder() {
        this.divTopPlaceholder = this.createPlaceholder();
        this.divPage.insertAdjacentElement('afterbegin', this.divTopPlaceholder);
        this.divBottomPlaceholder = this.createPlaceholder();
        this.divPage.insertAdjacentElement('beforeend', this.divBottomPlaceholder);
    }
    recalcStickySectionsPlaceholder() {
        const stickyTopSectionsHolderHeight = window.getComputedStyle(this.stickyTopSectionsHolder).height;
        const stickyBottomSectionsHolderHeight = window.getComputedStyle(this.stickyBottomSectionsHolder).height;
        this.divTopPlaceholder.style.height = stickyTopSectionsHolderHeight;
        this.divBottomPlaceholder.style.height = stickyBottomSectionsHolderHeight;
    }
    setupStickySections() {
        if (this.hasStickySections()) {
            this.repositionStickySections();
            this.createStickyPlaceholder();
            this.recalcStickySectionsPlaceholder();
            window.addEventListener('resize', () => {
                this.recalcStickySectionsPlaceholder();
            });
        }
    }
}
